// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Plus from '../_raw/ui/icon_plus.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Plus);
